import React from 'react';
import { IconPropsDeprecated } from '@umanforge/common';
import { CalendarSVG } from '@common_components/svg/calendar.svg';

const CalendarIcon: React.FC<IconPropsDeprecated> = ( { className = '', size = 7, onClick } ) => {
  return (
    <div className={`${className} w-${size} h-${size}`} onClick={onClick}>
      <CalendarSVG/>
    </div>
  );
};

export { CalendarIcon };
